<template>
  <div>
    <el-dialog
      title="开始"
      append-to-body
      :fullscreen="dialogFull"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      top="30px"
      :before-close="handleClose"
      :visible.sync="dialogShow"
      width="50%"
      :modal-append-to-body="false"
    >
      <template slot="title">
        <div class="avue-crud__dialog__header">
          <span class="el-dialog__title">
            开 始
          </span>
          <i
            class="el-icon-full-screen"
            style="margin-right:20px;position:relative;top:-1px"
            @click="dialogFull = !dialogFull"
          ></i>
        </div>
        <el-divider></el-divider>
      </template>
      <div style="max-height:calc(100vh - 320px);overflow-y:scroll;overflow-x:hidden;">
        <avue-form
          :option="option"
          v-model="form"
          ref="form"
          v-if="dialogShow"
          @submit="formSubmit"
          @error="formError"
        >
          <template slot="handleUserId">
            <el-input type="text" placeholder="请输入处理人" disabled v-model="handlePersonName">
            </el-input>
          </template>
          <template slot="remark">
            <div>
              <el-input
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入备注"
                v-model="form.remark"
              >
              </el-input>
              <remarkModel :remark.sync="form.remark" ref="scrapFormRemarkModel"></remarkModel>
            </div>
          </template>
          <template slot="attachList">
            <div>
              <vupload
                :fileList.sync="form.attachList"
                :limit="5"
                message="提示：请上传jpg,png或者MP4格式文件！"
                messageType="pre"
                :types="[
                  'audio/mp4',
                  'video/mp4',
                  'image/png',
                  'image/jpeg',
                  'image/x-png',
                  'image/pjpeg',
                ]"
                :max="20 * 1024 * 1024"
                typesFlag="multi"
              ></vupload>
            </div>
          </template>
          <!-- <template slot="menuForm">
              <el-button @click="handleClose" ><span class="el-icon-close"></span> 取消</el-button>
          </template> -->
        </avue-form>
      </div>
      <template slot="footer">
        <el-button @click="formSubmit1" size="small" type="primary"
          ><span class="el-icon-check"></span> 保存</el-button
        >
        <el-button @click="handleClose" size="small" style="margin-right:15px"
          ><span class="el-icon-close"></span> 取消</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { startOption } from './action-option.js';
import {
  getGroupDetails,
  getCooperateList,
  setCooperate,
  confirm,
  getRemarkList,
  start,
  getUserData,
  lazyAreaTree,
} from '@/api/crmedical/order/order-list/order-list';
import remarkModel from '../components/remark-model';
import vupload from '@/views/components/v-upload';
import { mapGetters } from 'vuex';
export default {
  components: {
    remarkModel,
    vupload,
  },
  data() {
    return {
      dialogFull: false,
      form: {
        orderId: '',
        attachList: [],
        handleUserId: '',
      },
      treeFormAreaData: [], //懒加载区域树 --报修表单中
      treeProps: {
        //报修表单 --需求区域树的配置
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      data: {},
      cheackedPeople: [],
      userList: [],
      dialogShow: false,
      option: startOption,
      handlePersonName: '',
    };
  },
  created() {},
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    console.log('userInfo----', this.userInfo);
    const { user_id } = this.userInfo;
    this.form.handleUserId = user_id;
    this.getUser(user_id);
  },
  methods: {
    getUser(id) {
      getUserData({ userId: id }).then(({ data }) => {
        console.log('getUserData---', data);
        const { realName, deptName, phone } = data;
        this.handlePersonName = `${realName}-${deptName}-${phone}`;
      });
    },
    // 弹窗关闭前
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.dialogShow = false;
        })
        .catch(() => {});
    },
    openDialog(data) {
      this.dialogShow = true;
      console.log('openDialog');
      this.data = data;
      this.tool.clearObject(this.form, 'handleUserId');
      this.form.orderId = data.orderId;
      console.log('this.form-', this.form);
      getRemarkList({ orderId: data.orderId, actionType: data.actionType }).then((res) => {
        this.$refs.scrapFormRemarkModel.setRemarkList(res.data);
      });
    },
    closeDialog() {
      this.dialogShow = false;
    },
    formError(done) {
      done();
    },
    formSubmit1() {
      this.$refs.form.submit();
    },
    formSubmit(form, done) {
      // let temForm = form;
      // temForm.orderId = form.orderId;
      // temForm.cooperateList = form.remark;
      start(form)
        .then((res) => {
          if (res.msg == '操作成功') {
            this.$message({
              message: res.msg,
              type: 'success',
            });
            this.dialogVisible = false;
            this.dialogShow = false;
          } else {
            this.$message.error(res.msg);
          }
          this.$emit('handleClose', function() {
            console.log('关闭历程表');
          });

          this.dialogShow = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
  },
};
</script>
